import { Leitungen } from "@/backend_controller/leitungen";
import Swal from 'sweetalert2';

export class LeitungenController {
    konvKey;
    mapRef;
    bounds;
    feuerwehrID;
    partnerFeuerwehren;
    alleLeitungen = [];
    aktiveLeitungen = [];
    alleLeitungspositionen = [];
    aktiveLeitungspositionen = [];
    ringleitungsPunkt = {
        lat: "",
        lng: ""
    };

    constructor(konvKey, mapRef, feuerwehrID, partnerFeuerwehren){
        this.konvKey = konvKey;
        this.mapRef = mapRef;
        this.feuerwehrID = feuerwehrID;
        this.partnerFeuerwehren = partnerFeuerwehren;
    }

    async init(aenderungszeitpunkt){
        await this.loadLeitungspositionen(aenderungszeitpunkt);
    }

    getLeitungspositionenInBounds(bounds){
        let padding = 0.000001; // ca. 1m Puffer
        const nord = bounds._northEast.lng + padding;
        const ost = bounds._northEast.lat + padding;
        const sued = bounds._southWest.lng - padding;
        const west = bounds._southWest.lat - padding;
        console.log("Bounds mit Puffer:", { nord, ost, sued, west });

        this.aktiveLeitungspositionen = this.alleLeitungspositionen.filter(leitung => {
            return leitung.position.y >= sued && leitung.position.y <= nord && leitung.position.x >= west && leitung.position.x <= ost;
        });

        this.aktiveLeitungen = this.aktiveLeitungspositionen
            .map(leitung => ({leitungsID: leitung.leitungsID, durchlaufmenge: leitung.durchlaufmenge}))
            .filter((obj, index, self) =>
                index === self.findIndex(o => o.leitungsID === obj.leitungsID)
            );
        //this.lineIntersectsBounds(bounds);
    }

    getAlleLeitungspositionenFromLeitungsID(leitungsID){
        return this.alleLeitungspositionen.filter(leitung => {
            return leitung.leitungsID == leitungsID;
        });
    }

    async loadLeitungspositionen(aenderungszeitpunkt){
        let response = await Leitungen.get(this.konvKey);
        if(response){
            this.alleLeitungspositionen = response;
            this.alleLeitungen = [...new Set(this.alleLeitungspositionen.map(leitung => leitung.leitungsID))];
            localStorage.setItem("leitungen", JSON.stringify(this.alleLeitungspositionen));
            localStorage.setItem("aenderungszeitpunktLeitung", aenderungszeitpunkt);
        } else {
            this.alleLeitungspositionen = JSON.parse(localStorage.getItem("leitungen"));
        }
    }

    /*lineIntersectsBounds(bounds) {
        let zusaetzlicheLeitungen = [];
        let uebrigeLeitungspositionen = this.alleLeitungspositionen.filter(leitung => !this.aktiveLeitungspositionen.some(a => a.leitungsID === leitung));
        uebrigeLeitungspositionen.forEach(p1 => {
            if(p1.nachfolger == null){
                return;
            } else{
                let p2 = uebrigeLeitungspositionen.find(pos => pos.positionsID === p1.nachfolger);
                if(p2){
                    const { _northEast, _southWest } = bounds;

                    // Eckpunkte
                    const minX = _southWest.lat, minY = _southWest.lng;
                    const maxX = _northEast.lat, maxY = _northEast.lng;

                    // Wenn beide Punkte links, rechts, oben oder unten des Rechtecks sind, keine Schnitt
                    if ((p1.position.x < minX && p2.position.x < minX) || (p1.position.x > maxX && p2.position.x > maxX) ||
                        (p1.position.y < minY && p2.position.y < minY) || (p1.position.y > maxY && p2.position.y > maxY)) {
                        
                    } else{
                        zusaetzlicheLeitungen.push(p1.leitungsID);
                    }
                }
            }
        });
        this.aktiveLeitungen.push(...new Set(zusaetzlicheLeitungen));
        console.log("Zusätzliche Leitungen, die die Bounds schneiden:", zusaetzlicheLeitungen);
    }*/
   async createRingleitung(latlng){
    if(this.ringleitungsPunkt.lat == "" || this.ringleitungsPunkt.lng == ""){
        this.ringleitungsPunkt.lat = latlng.lat;
        this.ringleitungsPunkt.lng = latlng.lng;
        if(localStorage.getItem("RettungspunkteHilfe")==1?true:false){
            Swal.fire(
                "Bitte Klicke noch auf einen zweiten Punkt auf der Karte"
            )
        }
    } else{
        let lat = latlng.lat;
        let lng = latlng.lng;

        let values = await this.ringleitungsForm();
        console.log(values);

        if(values == undefined){
            this.ringleitungsPunkt.lat = "";
            this.ringleitungsPunkt.lng = ""
            return;
        }
        let leitungsID = await Leitungen.getMaxLeitungsID(this.feuerwehrID);
        if(leitungsID == null){
            return;
        } else{
            leitungsID++;
        }

        let position1 = {
            leitungsID: leitungsID,
            positionsID: 500,
            position: {x: this.ringleitungsPunkt.lat, y: this.ringleitungsPunkt.lng},
            vorgaenger: null,
            nachfolger: null
        }

        let position2 = {
            leitungsID: leitungsID,
            positionsID: 501,
            position: {x: lat, y: lng},
            vorgaenger: 500,
            nachfolger: null
        }

        let response = await Leitungen.addRingleitung(leitungsID, values.durchlaufmenge, this.feuerwehrID, position1, position2);
        this.ringleitungsPunkt.lng = "";
        this.ringleitungsPunkt.lat = "";
        if(!response){
            return;
        }
        this.alleLeitungspositionen.push(position1);
        this.alleLeitungspositionen.push(position2);
        this.aktiveLeitungspositionen.push(position1);
        this.aktiveLeitungspositionen.push(position1);
        this.alleLeitungen.push(leitungsID);
        this.aktiveLeitungen.push({leitungsID: leitungsID, durchlaufmenge: Number(values.durchlaufmenge)});
    }
   }

   async ringleitungsForm(){
    let html = `<input id="durchlaufmenge" maxLength="3" class="swal2-input" placeholder="Durchlaufmenge" style="margin-left:0 !important; margin-right: 0 !important; width: 100% !important"><br>`
    const { value: formValues } = await Swal.fire({
        title: "Ringleitung hinzufügen",
        html: html,
        focusConfirm: false,
        preConfirm: () => {
        return [
            document.getElementById("durchlaufmenge").value,
        ];
        }
    });
    if (formValues) {
        const values = {
            durchlaufmenge: formValues[0]
        };
        return values;
        //this.saveWasserquelle(formValues[3], formValues[2], formValues[0], this.$props.lat, this.$props.lng, formValues[1]);
    }
   }

   async addLeitungsposition(latlng, altePosition){
    let positionsID;
    let vorgaenger = null;
    let nachfolger = null;
        if(altePosition.vorgaenger == null){
            positionsID = altePosition.positionsID - 1;
            vorgaenger = null;
            nachfolger = altePosition.positionsID;
        } else if(altePosition.nachfolger == null){
            positionsID = altePosition.positionsID + 1;
            vorgaenger = altePosition.positionsID;
            nachfolger = null;
        }
        
        let neuePosition = {
            leitungsID: altePosition.leitungsID,
            positionsID: positionsID,
            position: {x: latlng.lat, y: latlng.lng},
            vorgaenger: vorgaenger,
            nachfolger: nachfolger
        }

        console.log(altePosition);
        console.log(neuePosition);

        let response = await Leitungen.addLeitungsPosition(altePosition.leitungsID, positionsID, neuePosition.position, vorgaenger, nachfolger);
        if(!response){
            return;
        }
        this.alleLeitungspositionen.push(neuePosition);
        this.alleLeitungspositionen.sort((a, b) => {
            if (a.leitungsID !== b.leitungsID) {
                return a.leitungsID - b.leitungsID;
            }
            return a.positionsID - b.positionsID;
        });
        this.aktiveLeitungspositionen.push(neuePosition);
        this.aktiveLeitungspositionen.sort((a, b) => {
            if (a.leitungsID !== b.leitungsID) {
                return a.leitungsID - b.leitungsID;
            }
            return a.positionsID - b.positionsID;
        });

        if(vorgaenger != null){
            let vorgaengerPosition = this.alleLeitungspositionen.find(pos => pos.leitungsID === altePosition.leitungsID && pos.positionsID === vorgaenger);
            vorgaengerPosition.nachfolger = positionsID;
            let vorgaengerPositionAktiv = this.aktiveLeitungspositionen.find(pos => pos.leitungsID === altePosition.leitungsID && pos.positionsID === vorgaenger);
             if(vorgaengerPositionAktiv){
                vorgaengerPositionAktiv.nachfolger = positionsID;
             }
        } else if(nachfolger != null){
            let nachfolgerPosition = this.alleLeitungspositionen.find(pos => pos.leitungsID === altePosition.leitungsID && pos.positionsID === nachfolger);
            nachfolgerPosition.vorgaenger = positionsID;
            let nachfolgerPositionAktiv = this.aktiveLeitungspositionen.find(pos => pos.leitungsID === altePosition.leitungsID && pos.positionsID === nachfolger);
             if(nachfolgerPositionAktiv){
                nachfolgerPositionAktiv.vorgaenger = positionsID;
             }
        }
        this.aktiveLeitungen = this.aktiveLeitungen.filter(leitung => leitung.leitungsID !== altePosition.leitungsID);
        this.aktiveLeitungen.push({leitungsID: altePosition.leitungsID, durchlaufmenge: altePosition.durchlaufmenge});
   }
   async removeLeitungsposition(position){
        let vorgaengerPosition = this.alleLeitungspositionen.find(pos => pos.leitungsID === position.leitungsID && pos.positionsID === position.vorgaenger);
        let nachfolgerPosition = this.alleLeitungspositionen.find(pos => pos.leitungsID === position.leitungsID && pos.positionsID === position.nachfolger);
        if(vorgaengerPosition){
            vorgaengerPosition.nachfolger = position.nachfolger;
        }
        if(nachfolgerPosition){
            nachfolgerPosition.vorgaenger = position.vorgaenger;
        }
        let response = await Leitungen.removeLeitungsposition(position.leitungsID, position.positionsID);
        if(!response){
            return;
        }
        this.alleLeitungspositionen = this.alleLeitungspositionen.filter(pos => !(pos.leitungsID === position.leitungsID && pos.positionsID === position.positionsID));
        this.aktiveLeitungspositionen = this.aktiveLeitungspositionen.filter(pos => !(pos.leitungsID === position.leitungsID && pos.positionsID === position.positionsID));
    }
}